<template>
    <div id="FileDowload">
        <van-popup class="popup" v-model="show" position="right">
            <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft">
            </van-nav-bar>
            <iframe class="iframe" :src="fileDowloadUrl" frameborder="0"></iframe>
        </van-popup>
    </div>
</template>

<script>
export default {
    props: ['fileDowloadUrl'],
    data() {
        return {
            show: false
        }
    },
    methods: {
        open() {
            this.show = true;
        },

        onClickLeft() {
            this.show = false;
        },
    }
}
</script>

<style lang="scss">
@import "~@/assets/styles/theme";

#FileDowload {
    .popup {
        width: 100%;
        height: 100%;
    }

    .iframe {
        width: 100%;
        height: calc(100% - 46px);
    }

    .van-nav-bar {
        background-color: $theme-color;
    }

    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
        color: #fff !important;
        font-size: 0.18rem;
    }
}
</style>
